import React from 'react';

const BoxIdContext = React.createContext(null);
export default BoxIdContext;
